import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// Replace these values with your Firebase project config
const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Check if Firebase is configured
const isFirebaseConfigured = () => {
	return (
		firebaseConfig.apiKey &&
		firebaseConfig.apiKey !== "your-api-key-here" &&
		firebaseConfig.projectId &&
		firebaseConfig.projectId !== "your-project-id"
	);
};

// Initialize Firebase only if configured
let app = null;
let db = null;

if (isFirebaseConfigured()) {
	try {
		app = initializeApp(firebaseConfig);
		db = getFirestore(app);
		console.log("Firebase initialized successfully");
	} catch (error) {
		console.error("Error initializing Firebase:", error);
	}
} else {
	console.warn(
		"⚠️ Firebase is not configured. Please set up your .env file with Firebase credentials.\n" +
			"See FIREBASE_SETUP.md for instructions.\n" +
			"Submissions will be stored in localStorage as fallback."
	);
}

export { db, isFirebaseConfigured };
export default app;

